var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNorthmacedonia(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 10,
    viewBox: "0 0 40 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 24,
    transform: "translate(-3457 -9497)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 24
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b",
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 24,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3457 9515)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -18)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 24,
    transform: "translate(-3457 -9497)",
    fill: "#ed5200"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(-3440 -9488)",
    fill: "#ffce00"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 4,
    transform: "translate(-3457 -9487)",
    fill: "#ffce00"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 4,
    transform: "translate(-3432 -9487)",
    fill: "#ffce00"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 4,
    transform: "translate(-3435 -9480) rotate(90)",
    fill: "#ffce00"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 4,
    transform: "translate(-3435 -9497) rotate(90)",
    fill: "#ffce00"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 4,
    transform: "translate(-3458 -9502) rotate(30)",
    fill: "#ffce00"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 4,
    transform: "translate(-3460 -9472) rotate(-30)",
    fill: "#ffce00"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 4,
    transform: "translate(-3414.412 -9498.536) rotate(150)",
    fill: "#ffce00"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 4,
    transform: "translate(-3416.412 -9468.536) rotate(-150)",
    fill: "#ffce00"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-3541.218-8606h-5.49l-14.51,24h20Z",
    transform: "translate(124.218 -891)",
    opacity: 0.095
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNorthmacedonia);
export default __webpack_public_path__ + "static/media/NORTH MACEDONIA.39c88c370a2979b00b67543dc748d2e8.svg";
export { ForwardRef as ReactComponent };